import { type ElementType } from 'react';

import Contact from '../pages/Contact/Contact';
import Home from '../pages/Home/Home';
import AppliedJobs from '../pages/JobPortal/AppliedJobs';
import ApplyJob from '../pages/JobPortal/ApplyJob';
import Assessment from '../pages/JobPortal/Assessment';
import JobDetails from '../pages/JobPortal/JobDetails';
import JobPortal from '../pages/JobPortal/JobPortal';
import OfferLetter from '../pages/JobPortal/OfferLetter';
import NotFound from '../pages/NotFound';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import RefundPolicy from '../pages/RefundPolicy/RefundPolicy';
import TakeInterview from '../pages/TakeInterview/TakeInterview';
import legacyRedirect from './LegacyRedirect';
import { PATHS, ROUTE_PATTERNS } from './paths';

type AppRoute = {
  path: string;
  element: ElementType;
  /** Requires a signed-in applicant. */
  protected?: boolean;
};

const JOB_PORTAL = ROUTE_PATTERNS.jobPortal;

/* ------------------------------ Marketing ------------------------------ */

const MARKETING_ROUTES: AppRoute[] = [
  { path: PATHS.home, element: Home },
  { path: PATHS.contact, element: Contact },
  { path: PATHS.privacyPolicy, element: PrivacyPolicy },
  { path: PATHS.refundPolicy, element: RefundPolicy },
];

/* ------------------------------ Job portal ----------------------------- */

const JOB_PORTAL_ROUTES: AppRoute[] = [
  // Open to everyone
  { path: JOB_PORTAL.root, element: JobPortal },
  { path: JOB_PORTAL.job, element: JobDetails },
  { path: JOB_PORTAL.apply, element: ApplyJob },

  // Applicant area
  { path: JOB_PORTAL.applications, element: AppliedJobs, protected: true },
  { path: JOB_PORTAL.assessment, element: Assessment, protected: true },
  { path: JOB_PORTAL.interview, element: TakeInterview },
  { path: JOB_PORTAL.offers, element: OfferLetter, protected: true },
];

/* --------------------------- Legacy redirects -------------------------- */

// Old job portal URLs (shared links, emails, bookmarks) → current paths.
const LEGACY_ROUTES: AppRoute[] = [
  {
    path: '/job-portal/applied-jobs',
    element: legacyRedirect(() => PATHS.jobPortal.applications),
  },
  {
    path: '/job-portal/offer-letters',
    element: legacyRedirect(() => PATHS.jobPortal.offers),
  },
  {
    path: '/job-portal/assessment/:applicationId',
    element: legacyRedirect(({ applicationId }) =>
      PATHS.jobPortal.assessment(applicationId!),
    ),
  },
  {
    path: '/job-portal/interview/:applicationId',
    element: legacyRedirect(({ applicationId }) =>
      PATHS.jobPortal.interview(applicationId!),
    ),
  },
  {
    path: '/job-portal/:jobId/apply',
    element: legacyRedirect(({ jobId }) => PATHS.jobPortal.apply(jobId!)),
  },
  {
    path: '/job-portal/:jobId',
    element: legacyRedirect(({ jobId }) => PATHS.jobPortal.job(jobId!)),
  },
];

export const PUBLIC_ROUTES: AppRoute[] = [
  ...MARKETING_ROUTES,
  ...JOB_PORTAL_ROUTES,
  ...LEGACY_ROUTES,
  { path: '*', element: NotFound },
];
